//import type { UseQueryOptions } from '@tanstack/react-query';
//import { useQuery } from '@tanstack/react-query';
import type { TranscriptComment } from '@trinity/chat/types/transcribe.rich-text';
import { type UseQueryOptions, useQueryWrapper } from '@trinity/chat-components';
import type { AxiosResponse } from 'axios';

type Props = {
  transcriptId: number;
};

export const useTranscriptionComments = (props: Props, options: Omit<Options, 'queryKey' | 'queryFn'> = {}) => {

  const query = useQueryWrapper({
    queryKey: ['transcript-comments', props],
    queryFn: ({ queryKey }) => {
      /*const params = queryKey[1] as Props;
      return apiClient.transcripts.getTranscriptComments(params)
        .then(res => res.comments);
        */
      return Promise.resolve([] as TranscriptComment[]);
    },
    ...options,
  });

  return query;
};

type Data = TranscriptComment[];
type QK = readonly [string, Props];

type Options = UseQueryOptions<Data, AxiosResponse, Data, QK>;